import { AxiosPromise } from "axios";
import configs from "../../configs";
import { AxiosGlobal } from "../shared/axios";
import { createPublicApiHeaders } from "../utils/apiHeaders";
import {
  SupportChatRequest,
  SupportChatResponse,
} from "../supportChatApis";

/** Update this path when the backend endpoint is ready. */
export const SUPPORT_CHAT_ENDPOINT = `${configs.context}/support/chat`;

export class SupportChatLiveApis extends AxiosGlobal {
  sendMessage(data: SupportChatRequest): AxiosPromise<SupportChatResponse> {
    return this.axios.post(SUPPORT_CHAT_ENDPOINT, data, {
      headers: createPublicApiHeaders(),
    });
  }
}
